import React, { useRef, useState } from "react";
import { CloudArrowUp, MusicNotes, X } from "@phosphor-icons/react";

export default function UploadZone({ onFile, busy }) {
  const [drag, setDrag] = useState(false);
  const [file, setFile] = useState(null);
  const inputRef = useRef(null);

  const accept = ".mp3,.wav,.m4a,.mp4,.webm,.mpeg,.mpga,audio/*";

  const handle = (f) => {
    if (!f) return;
    setFile(f);
    onFile(f);
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        const f = e.dataTransfer.files?.[0];
        if (f) handle(f);
      }}
      className={`border-2 border-dashed ${drag ? "border-[--ink] bg-gray-100" : "border-[--ink]/30 bg-white"} p-10 text-center transition-colors`}
      data-testid="upload-zone"
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        data-testid="audio-file-input"
        onChange={(e) => handle(e.target.files?.[0])}
      />
      {!file ? (
        <>
          <CloudArrowUp weight="duotone" size={56} className="mx-auto mb-4 text-[--ink]" />
          <h3 className="font-display text-2xl font-bold tracking-tight mb-2">Drop audio here</h3>
          <p className="text-sm text-[--muted] mb-6">
            <span className="font-mono">.mp3 .wav .m4a .webm .mp4</span> up to <span className="font-mono">1 GB</span>
          </p>
          <button
            onClick={() => inputRef.current?.click()}
            disabled={busy}
            data-testid="choose-file-btn"
            className="bg-[--ink] text-white px-5 py-3 text-sm font-bold hover:bg-[--accent] transition-colors disabled:opacity-50"
          >
            Choose file
          </button>
        </>
      ) : (
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <MusicNotes weight="duotone" size={32} />
          <div className="text-left">
            <div className="font-mono text-sm" data-testid="selected-file-name">{file.name}</div>
            <div className="font-mono text-xs text-[--muted]">
              {(file.size / (1024 * 1024)).toFixed(2)} MB
            </div>
          </div>
          <button
            onClick={() => { setFile(null); inputRef.current.value = ""; onFile(null); }}
            disabled={busy}
            className="border border-[--ink] p-2 hover:bg-[--ink] hover:text-white transition-colors disabled:opacity-50"
            aria-label="Clear"
            data-testid="clear-file-btn"
          >
            <X weight="bold" size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
